<div class="robot-selector-container" [testId]="'robot-selector-container'">
  <div class="selector-toolbar">
    <div class="binding-legend">
      <span class="legend-title">{{ 'robot-service.my.binding-legend' | i18n }}</span>
      <span class="legend-item"> <span class="dot dot-free"></span>{{ 'robot-service.my.binding.legend.unbound' | i18n }} </span>
      <span class="legend-item"> <span class="dot dot-current"></span>{{ 'robot-service.my.binding.legend.current' | i18n }} </span>
      <span class="legend-item"> <span class="dot dot-occupied"></span>{{ 'robot-service.my.binding.legend.occupied' | i18n }} </span>
      <span class="legend-item"> <span class="dot dot-expired"></span>{{ 'robot-service.my.binding.legend.expired' | i18n }} </span>
    </div>
  </div>

  <nz-spin [nzSpinning]="loading" [testId]="'robot-selector-spin'">
    <div class="cards" [testId]="'robot-selector-cards'">
      <div
        class="robot-card"
        *ngFor="let robot of displayList; let i = index"
        (click)="select(robot)"
        [class.selected]="isSelected(robot)"
        [class.robot-card-current]="isCurrent(robot)"
        [class.robot-card-expired]="isExpired(robot)"
        [class.robot-card-disabled]="isExpired(robot) || isDisabled(robot) || (hasPendingPayment(robot) && !canPayPendingOrder(robot))"
        [class.robot-card-trial]="isTrial(robot) && !isExpired(robot) && !isDisabled(robot)"
        [class.robot-card-occupied]="isBoundElsewhere(robot)"
        [class.robot-card-available]="!isCurrent(robot) && !isExpired(robot) && !isDisabled(robot) && !isTrial(robot)"
        [testId]="'robot-card-' + i"
      >
        <div class="card-left">
          <div class="avatar">
            <i nz-icon nzType="robot" nzTheme="outline"></i>
            <span class="avatar-dot" [ngClass]="getBindingDotClass(robot)"></span>
          </div>
        </div>
        <div class="card-main">
          <div class="name-row">
            <div class="name-line">
              <ng-container *ngIf="!isRenaming(robot); else renameInputTpl">
                <span class="name" [title]="robot.name">{{ robot.name }}</span>
                <nz-tag
                  *ngIf="robot.identityType || (robot.type && robot.type !== 'Gpt')"
                  class="type-tag"
                  [class.type-tag-virtual-persona]="isVirtualPersona(robot)"
                  [class.type-tag-virtual-employee]="isVirtualEmployee(robot)"
                  [nzColor]="getRobotTypeTagColor(robot)"
                >
                  <i *ngIf="isVirtualPersona(robot)" nz-icon nzType="share-alt" nzTheme="outline"></i>
                  <i *ngIf="isVirtualEmployee(robot)" nz-icon nzType="user" nzTheme="outline"></i>
                  {{ getRobotTypeInfo(robot.type, robot.identityType).label }}
                </nz-tag>
                <nz-tag
                  *ngIf="!canCancelAttach(robot) && !hasPendingPayment(robot) && !isExpired(robot) && !isDisabled(robot)"
                  class="status-tag"
                  [nzColor]="getStatusColor(robot)"
                >
                  {{ getStatusLabel(robot) }}
                </nz-tag>
                <nz-tag *ngIf="canCancelAttach(robot)" nzColor="processing">
                  {{ 'robot-service.my.current-used' | i18n }}
                </nz-tag>
              </ng-container>
              <ng-template #renameInputTpl>
                <div class="rename-inline">
                  <input
                    class="rename-input"
                    [(ngModel)]="renameInputValue"
                    (click)="$event.stopPropagation()"
                    (keydown.enter)="saveRename(robot)"
                    [disabled]="isRenamingSubmitting(robot)"
                    [placeholder]="'robot-service.my.rename-placeholder' | i18n"
                    [testId]="'robot-selector-rename-input-' + i"
                  />
                  <button
                    nz-button
                    nzType="text"
                    nzSize="small"
                    class="name-icon-btn name-save-btn"
                    [nzLoading]="isRenamingSubmitting(robot)"
                    (click)="$event.stopPropagation(); saveRename(robot)"
                    [title]="'common.save' | i18n"
                    [testId]="'robot-selector-rename-save-button-' + i"
                  >
                    <i nz-icon nzType="check" nzTheme="outline"></i>
                  </button>
                  <button
                    nz-button
                    nzType="text"
                    nzSize="small"
                    class="name-icon-btn name-cancel-btn"
                    [disabled]="isRenamingSubmitting(robot)"
                    (click)="$event.stopPropagation(); cancelRename()"
                    [title]="'common.cancel' | i18n"
                    [testId]="'robot-selector-rename-cancel-button-' + i"
                  >
                    <i nz-icon nzType="close" nzTheme="outline"></i>
                  </button>
                </div>
              </ng-template>
              <nz-tag
                *ngIf="getOrderStatusTag(robot).show"
                class="order-tag"
                [nzColor]="getOrderStatusTag(robot).color"
                [testId]="'robot-order-tag-' + i"
              >
                {{ getOrderStatusTag(robot).label }}
              </nz-tag>
            </div>
          </div>
          <div class="meta-row meta-row-binding">
            <span class="meta-value">
              <span
                class="binding-chip"
                [class.binding-chip-occupied]="isBoundElsewhere(robot)"
                [class.binding-chip-current]="canCancelAttach(robot)"
                [class.binding-chip-unbound]="isAttachable(robot)"
                [class.binding-chip-disabled]="
                  isExpired(robot) || isDisabled(robot) || (hasPendingPayment(robot) && !canPayPendingOrder(robot))
                "
              >
                <i nz-icon nzType="link" nzTheme="outline"></i>
                {{ getBindingChipText(robot) }}
              </span>
            </span>
          </div>
          <div class="meta-row meta-row-single">
            <span class="meta-value meta-expire-line">
              <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
              <ng-container *ngIf="getRemainingDays(robot) !== null; else expireOnlyTpl">
                <span class="expire-prefix">{{ getRemainingLabel(robot) }}：</span>
                <span class="expire-days">{{ getRemainingDays(robot) }} {{ 'robot-service.my.days' | i18n }}</span>
                <span class="expire-date-prefix">{{ 'robot-service.my.expire-date' | i18n }}：</span>
              </ng-container>
              <ng-template #expireOnlyTpl>
                <span class="expire-date-prefix">{{ 'robot-service.my.expire-date' | i18n }}：</span>
              </ng-template>
              <span class="expire-date-value">{{ hasValidExpireTime(robot) ? (robot.expireTime | date: 'yyyy-MM-dd') : '-' }}</span>
              <ng-container *ngIf="getTodayUsageText(robot)">
                <span class="today-usage">{{ 'robot-service.my.today-usage' | i18n }} {{ getTodayUsageText(robot) }}</span>
              </ng-container>
            </span>
          </div>
        </div>
        <div class="card-right">
          <div class="card-top-status" *ngIf="hasPendingPayment(robot) || isExpired(robot) || isDisabled(robot)">
            <div
              class="pending-status-chip"
              [class.pending-status-chip-expired]="!canPayPendingOrder(robot)"
              *ngIf="hasPendingPayment(robot)"
            >
              <i nz-icon nzType="hourglass" nzTheme="outline"></i>
              <span>{{ 'payment.result.countdown.label' | i18n }}</span>
              <strong>{{ getPendingPaymentCountdown(robot) }}</strong>
            </div>
            <div class="expired-status-chip" *ngIf="isExpired(robot) && !hasPendingPayment(robot)">
              <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
              <span>{{ 'robot-service.my.expired' | i18n }}</span>
            </div>
            <div class="expired-status-chip" *ngIf="isDisabled(robot) && !hasPendingPayment(robot)">
              <i nz-icon nzType="pause-circle" nzTheme="outline"></i>
              <span>{{ 'robot-service.my.binding.disabled' | i18n }}</span>
            </div>
          </div>
          <div class="card-actions">
            <button
              nz-button
              nzType="default"
              nzSize="small"
              class="action-btn action-detach"
              *ngIf="canCancelAttach(robot)"
              (click)="$event.stopPropagation(); cancelAttach(robot)"
              [nzLoading]="isDetaching(robot)"
              [testId]="'robot-selector-detach-button-' + i"
            >
              <i nz-icon nzType="disconnect" nzTheme="outline"></i>
              {{ 'servicenumber.robot.button.detach' | i18n }}
            </button>
            <button
              nz-button
              nzType="default"
              nzSize="small"
              class="action-btn action-attach"
              *ngIf="!isExpired(robot) && !isDisabled(robot) && !canCancelAttach(robot) && !hasPendingPayment(robot)"
              (click)="$event.stopPropagation(); attach(robot)"
              [disabled]="!isAttachable(robot)"
              [nzLoading]="isAttaching(robot)"
              [testId]="'robot-selector-attach-button-' + i"
            >
              <i nz-icon nzType="link" nzTheme="outline"></i>
              {{ getAttachButtonLabel(robot) }}
            </button>
          </div>
        </div>
        <div class="card-footer-actions">
          <button
            nz-button
            nzType="primary"
            nzSize="small"
            class="action-btn action-buy"
            *ngIf="isTrial(robot) && !isExpired(robot) && !isDisabled(robot) && !hasPendingPayment(robot)"
            (click)="$event.stopPropagation(); openPurchase('buy', robot)"
            [testId]="'robot-selector-buy-button-' + i"
          >
            {{ 'robot-service.my.buy-now' | i18n }}
          </button>
          <button
            nz-button
            nzType="default"
            nzSize="small"
            class="action-btn action-pay"
            *ngIf="hasPendingPayment(robot) && !isExpired(robot) && !isDisabled(robot) && canPayPendingOrder(robot)"
            (click)="$event.stopPropagation(); payPendingOrder(robot)"
            [attr.aria-label]="'robot-service.purchase.pay' | i18n"
            [testId]="'robot-selector-pay-button-' + i"
          >
            <span class="pay-title">
              <i nz-icon nzType="wallet" nzTheme="outline"></i>
              <span>{{ 'robot-service.purchase.pay' | i18n }}</span>
            </span>
          </button>
          <button
            nz-button
            nzType="default"
            nzSize="small"
            class="action-btn action-cancel-order"
            *ngIf="canCancelPendingOrder(robot)"
            (click)="$event.stopPropagation(); cancelPendingOrder(robot)"
            [nzLoading]="isCancelingPendingOrder(robot)"
            [disabled]="!!cancelingOrderId && !isCancelingPendingOrder(robot)"
            [testId]="'robot-selector-cancel-order-button-' + i"
          >
            <i nz-icon nzType="close-circle" nzTheme="outline"></i>
            {{ 'robot-service.order.cancel' | i18n }}
          </button>
          <button
            nz-button
            nzType="default"
            nzSize="small"
            class="action-btn action-package"
            (click)="$event.stopPropagation(); openOrderHistory(robot)"
            [testId]="'robot-selector-package-history-button-' + i"
          >
            {{ 'robot-service.my.package-history' | i18n }}
          </button>
          <button
            nz-button
            nzType="default"
            nzSize="small"
            class="action-btn action-rename"
            *ngIf="!isRenaming(robot)"
            (click)="$event.stopPropagation(); startRename(robot)"
            [testId]="'robot-selector-rename-button-' + i"
          >
            <i nz-icon nzType="edit" nzTheme="outline"></i>
            {{ 'robot-service.my.rename' | i18n }}
          </button>
          <button
            nz-button
            nzType="default"
            nzSize="small"
            class="action-btn action-renew"
            [class.action-renew-expired]="isExpired(robot)"
            [class.action-renew-current]="isCurrent(robot)"
            *ngIf="isExpired(robot) || (!isTrial(robot) && !hasPendingPayment(robot))"
            (click)="$event.stopPropagation(); openPurchase('renew', robot)"
            [testId]="'robot-selector-renew-button-' + i"
          >
            {{ 'robot-service.my.renew' | i18n }}
          </button>
          <button
            nz-button
            nzType="default"
            nzSize="small"
            class="action-btn action-delete"
            [disabled]="isCurrent(robot)"
            [nzLoading]="isDeleting(robot)"
            (click)="$event.stopPropagation(); removeRobot(robot)"
            [testId]="'robot-selector-delete-button-' + i"
          >
            <i nz-icon nzType="delete" nzTheme="outline"></i>
            {{ 'common.delete' | i18n }}
          </button>
        </div>
      </div>
    </div>
  </nz-spin>

  <div class="footer-actions" [testId]="'robot-selector-footer-actions'">
    <button nz-button nzType="primary" class="buy-new-btn" (click)="buyNew()" [testId]="'robot-selector-buy-new'">
      <i nz-icon nzType="shopping-cart"></i>
      <span class="btn-main">{{ 'robot-service.my.buy-new' | i18n }}</span>
    </button>
  </div>
</div>
